export default __webpack_public_path__ + "static/media/background.5ce05b57.jpg";